export default {
  setWindowList(state, payload) {
    state.windowList = payload;
  },
  setWindowDetails(state, payload) {
    const {
      window = {},
      destination_zipcodes = null,
      name: name_schema = null,
      origin_zipcode = null,
      source = null,
      enabled: enabled_schema,
      id: id_schema,
    } = payload || {};

    state.windowDetails = Object.assign(window, {
      destination_zipcodes,
      name_schema,
      origin_zipcode,
      source,
      enabled_schema,
      id_schema,
    });
  },
  toggleLoading(state, payload) {
    state.loading = payload;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-capacity-management/features/window/store/mutations.js